export default __webpack_public_path__ + "static/graphik-web-semibold-8a3af326bd851b42226e6e25ab92edfc.woff2";